define('entities/pim_product_alternative',[
  'app',
  'jquery',
  'settings',
  'backbone'
], function (
  App,
  $,
  Settings,
  Backbone
) {
  'use strict';

  var ProductAlternative = Backbone.Model.extend({
    defaults: {
      productCode: '',
      productName: '',
      catalogPictureUid: ''
    },

    url: function () {
      var base = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + this.get('productSecId') + '/alternatives/');
      if (this.isNew()) {
        return base;
      }
      return base + this.get('id');
    },

    idAttribute: 'id'
  });

  var ProductAlternativeCollection = Backbone.Collection.extend({
    fetch: function (productSecId) {
      this.productSecId = productSecId;
      this.url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + productSecId + '/alternatives/');
      var that = this;
      return Backbone.Collection.prototype.fetch.call(this).done(function () {
        that.each(function (model) {
          model.set('productSecId', that.productSecId, {silent: true});
        });
      });
    },
    model: ProductAlternative
  });

  App.reqres.setHandler('pim:product-alternative:collection', function (productAlternativesJSON) {
    return new ProductAlternativeCollection(productAlternativesJSON);
  });
  App.reqres.setHandler('pim:product-alternative:model', function (productAlternativeJSON) {
    return new ProductAlternative(productAlternativeJSON);
  });
});

